import { PayloadAction, createSelector, createSlice } from "@reduxjs/toolkit";

import { SliceKeys, tablePaginationInitialValue } from "@sso/constant";
import { RootState } from "@sso/store";
import { SearchColumn } from "@sso/types";
import { getTableSortColumn, queryBuilder } from "@sso/utils";

export const LicenceSlice = createSlice({
  name: SliceKeys.LICENCE,
  initialState: { pagination: tablePaginationInitialValue },
  reducers: {
    setLicencePageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.pageSize = action.payload;
    },
    setLicencePageIndex: (state, action: PayloadAction<number>) => {
      state.pagination.pageIndex = action.payload;
    },
    setLicenceSearchColumn: (state, action: PayloadAction<SearchColumn>) => {
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
      state.pagination.search[action.payload.column] = action.payload;
    },
    clearLicenceSearchColumn: (state, action: PayloadAction<string>) => {
      const { [action.payload]: deleteItem, ...otherSearchItems } = state.pagination.search;
      state.pagination.search = otherSearchItems;
    },
    setLicenceSortColumn: (state, action: PayloadAction<string>) => {
      const { column, type } = state.pagination.sort;
      state.pagination.sort = getTableSortColumn(column, action.payload, type);
      state.pagination.pageIndex = tablePaginationInitialValue.pageIndex;
    },
  },
});

export const {
  setLicencePageSize,
  setLicencePageIndex,
  setLicenceSortColumn,
  setLicenceSearchColumn,
  clearLicenceSearchColumn,
} = LicenceSlice.actions;

export const selectLicencePagination = createSelector(
  (state: RootState) => state.licence.pagination,
  ({ pageSize, totalPages, pageIndex, sort, search }) => ({
    pageSize: { action: setLicencePageSize, value: pageSize },
    pagination: {
      totalPages,
      pageIndex,
      action: setLicencePageIndex,
    },
    sort,
    search: { object: search, onChange: setLicenceSearchColumn, onClear: clearLicenceSearchColumn },
  }),
);

export const selectLicenceQuery = createSelector(
  (state: RootState) => state.licence.pagination,
  ({ pageSize, pageIndex, search, sort }) => queryBuilder(pageSize, pageIndex, search, sort),
);

export default LicenceSlice.reducer;
